import { render } from "./PraticaSpostamentoContatore.vue?vue&type=template&id=409ec52a&scoped=true"
import script from "./PraticaSpostamentoContatore.vue?vue&type=script&lang=js"
export * from "./PraticaSpostamentoContatore.vue?vue&type=script&lang=js"

import "./PraticaSpostamentoContatore.vue?vue&type=style&index=0&id=409ec52a&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409ec52a"]])

export default __exports__